

import _ from 'lodash';
import vb from 'validation-builder';
import {ValidatableMixin} from 'validatable';

const {
	Address,
	AddressComponent,
	AddressStreetComponent,
	AddressSettlementComponent,
} = require('./address');


const ValidatableAddressComponentMixin = (superclass) => {
	return class extends ValidatableMixin(superclass) {
		constructor (options) {
			super(...arguments);

			const { dictionary } = options;

			this.Name = this.Name
				.extend({
					required: true,
					validation: [{
						validator: (v) => dictionary.has(v),
						message: 'выберите из меню',
					}],
				});
		}

		validationArray () {
			return [
				this.Kladr,
				this.Name,
			];
		}
	};
};

class ValidatableAddressComponent
extends ValidatableAddressComponentMixin(AddressComponent) {}

class ValidatableAddressSettlementComponent
extends ValidatableAddressComponentMixin(AddressSettlementComponent) {
	constructor (options) {
		super(...arguments);

		const { dictionaryRsa } = options;

		this.NameRsa.extend({
			required: true,
			validation: [{
				validator: (v) => dictionaryRsa.has(v),
				message: 'выберите из меню',
			}],
		});
	}

	validationArray ({ rsa }) {
		const arr = super.validationArray(...arguments);

		if (rsa) {
			_.pull(arr, this.Name);
			arr.push(this.NameRsa);
		}

		return arr;
	}
}

class ValidatableAddressStreetComponent
extends ValidatableAddressComponentMixin(AddressStreetComponent) {}

class ValidatableAddress extends ValidatableMixin(Address) {
	constructor (...args) {
		super(...args);

		this.House = this.House.extend({
			validation: vb.all([
				vb.required(),
				vb.regex(/^[-ЁА-Яёа-я\d \.,\/]*$/i),
			]),
		});
	}

	_newAddressStreetComponent (options, ...args) {
		const street = new ValidatableAddressStreetComponent(options, ...args);

		street.Name.extend({ validatable: false })
			.extend({
				validation: vb.all([
					vb.if(() => this.HasStreets(), vb.all([
						vb.required(),
						vb.custom((v) => options.dictionary.has(v), 'выберите из меню'),
					])),
				]),
			});

		return street;
	}

	_newAddressSettlementComponent (...args) {
		return new ValidatableAddressSettlementComponent(...args);
	}

	validationArray (...args) {
		return [
			this.House,
			this.Apartement,
		]
			.concat(this.Settlement.validationArray(...args))
			.concat(
				this.HasStreets()
					? this.Street.validationArray(...args)
					: []
			)
		;
	}
}


module.exports = {
	ValidatableAddress,
	ValidatableAddressComponent,
	ValidatableAddressStreetComponent,
	ValidatableAddressSettlementComponent,
};
